import React from 'react'
import styled from 'styled-components'

export default (props) => (
  <Wrapper>
    {props.children}
  </Wrapper>
)

const Wrapper = styled.div`
  background: ${({theme}) => theme.yellow};
  padding: 1rem;
  color: #fff;
  
  @media all and (max-width: 360px) {
    padding: .2rem 1rem;
  }
`
